import EL, { HTMLELEMENT } from '../../EL/EL.js';
import Refreshable, { Refresh } from '../../../interface/Refreshable.js';
import TGROUPFACTORY, { factoryModel } from '../../DOM/table/TGROUPFACTORY.js';
import { tbody } from '../../DOM/table/TGROUP/TBODY.js';
import { tfoot } from '../../DOM/table/TGROUP/TFOOT.js';
import { thead } from '../../DOM/table/TGROUP/THEAD.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const tableAttr = makeAttrStruct([
    ['border'],
    ['cellpadding'],
    ['cellspacing'],
    ['width'],
    ['height']
]);
export const tableData = makeDataStruct([
    ['thead', thead('thead')],
    ['tbody', tbody('tbody')],
    ['tfoot', tfoot('tfoot')]
]);
export const tableModel = makeStruct([
    ['attributes', tableAttr],
    ['data', tableData]
]);
/** A TABLE Element */
export default class TABLE extends EL {
    thead;
    tbody;
    tfoot;
    constructor(node, model) {
        super(node, HTMLELEMENT.TABLE, model);
        this.addClass('table');
        this.implement(new Refreshable(this));
        this.tgroupFactory = new TGROUPFACTORY(factoryModel(), this);
        this.thead = this.tgroupFactory.create('THEAD', model.data.thead);
        this.tbody = this.tgroupFactory.create('TBODY', model.data.tbody);
        this.tfoot = this.tgroupFactory.create('TFOOT', model.data.tfoot);
    }
    getColumnNames() {
        return this.thead.get()[0].get().map((col) => col.getName());
    }
    // /** Triggers a download link that saves the table contents as a CSV */
    // downloadCSV(): void {
    // 	let data = '';
    // 	data += this.getColumnNames().join(',') + '\n';
    // 	this.recordset.forEach((record) => {
    // 		let cols: string[] = [];
    // 		this.getColumnNames().forEach((colName) => cols.push(record[colName]));
    // 		data += cols.join(',') + '\n';
    // 	});
    // 	let bl = new Blob([data], {
    // 		type: "text/html"
    // 	});
    // 	let a = document.createElement("a");
    // 	a.href = URL.createObjectURL(bl);
    // 	a.download = "report.csv";
    // 	a.hidden = true;
    // 	document.body.appendChild(a);
    // 	a.click();
    // 	a.remove();
    // }
    // /** Triggers a form for creating a new record in this table	*/
    // postRecord(): void {
    // 	console.log('TODO: Launch Form to add record');
    // }
    /** Empties the TBODY */
    emptyBody() {
        this.tbody.empty(false);
        return this;
    }
}
export { EL, Refresh, Refreshable }; //TBODY, TGROUP, THEAD, TFOOT
